// Функция для получения размера из строки
export const extractSize = (input) => {
    const match = input.match(/\d{3,4}(x\d{3,4})?/);
    return match ? match[0] : null;
};

// Функция для получения размера из строки (с высотой)
export const extractSizeWidthHeight = (input) => {
    const match = input.match(/(\d{3,4})x(\d{3,4})x(\d{3,4})/);
    if (!match) return null;

    const [, height, width, depth] = match;
    return {
        height: Number(height),
        width: Number(width),
        depth: Number(depth),
    };
};
